<template>
  <div>
    <div class="mb-1 d-flex flex-row">
      <div style="flex:1;" class="pr-2">
        <h6 style="color: #101010;">
          {{ $l('form_header_factory') || '验厂要求' }}
        </h6>
      </div>
    </div>

    <el-form ref="baseForm" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_isFactoryInspection') || '是否需要验厂'"
          >
            <el-select
              v-model="formData.isFactoryInspection"
              :placeholder="
                $l('form_placeholder_isFactoryInspection') ||
                  '请选择是否需要验厂'
              "
              filterable
              clearable
              style="width: 100%"
            >
              <el-option
                value="Y"
                :label="$l('form_label_isFactoryInspection_Y') || '需要验厂'"
              />
              <el-option
                value="N"
                :label="$l('form_label_isFactoryInspection_N') || '不需要验厂'"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_factoryInspectionMethods') || '验厂方式'"
          >
            <dict-select
              v-model="formData.factoryInspectionMethods"
              :placeholder="
                $l('form_placeholder_factoryInspectionMethods') ||
                  '请选择验厂方式'
              "
              url="/digitalCenter/common/dict/system"
              :body="{ dictType: 'factoryInspectionMethods' }"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="d-flex align-items-center my-3">
      <h6 class="m-0">{{ $l('form_header_factoryDoc') || '客户验厂资料' }}</h6>
      <el-divider direction="vertical" />
      <b-button size="sm" variant="outline-success" @click="addDoc">
        {{ $l('btn_addDoc') || '新增资料' }}
      </b-button>
    </div>

    <div class="cust-doc-list">
      <el-form
        v-for="(form, index) in listDoc"
        :key="index"
        ref="form"
        :model="form"
        :rules="docRules"
        size="mini"
      >
        <div class="d-flex">
          <div>
            <div>
              <el-avatar
                shape="square"
                :src="form.custFileIcon"
                :class="{ 'bg-transparent': form.custFileIcon }"
              />
            </div>
            <div class="text-center mt-2">
              <el-tooltip
                effect="dark"
                :content="$l('INDEX.btn_tips_del') || '删除'"
                placement="left-end"
              >
                <i
                  class="el-icon-delete text-danger tool-btn"
                  style="font-size: larger;"
                  @click="deleteDoc(index)"
                />
              </el-tooltip>
            </div>
          </div>
          <div style="flex:1;padding-left: 16px;">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_custFileName') || '文件名称'"
                  prop="custFileName"
                >
                  <el-input
                    v-model="form.custFileName"
                    :placeholder="
                      $l('form_placeholder_custFile') || '请选择文件'
                    "
                    readonly
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-folder-opened"
                      @click="uploadDoc(index)"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_custFileDesc') || '文件类型（可多选）'"
                  prop="custFileDescCodes"
                >
                  <dict-select
                    v-model="form.custFileDescCodes"
                    url="/master/common/dict/biz"
                    :body="{ dictType: 'custFileDescType' }"
                    :placeholder="
                      $l('form_placeholder_custFileDesc') ||
                        '请选择文件类型（可多选）'
                    "
                    :selectedLabel.sync="form.custFileDesc"
                    selectedLabelSeparator="、"
                    filterable
                    clearable
                    multiple
                    size="mini"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="
                    $l('form_label_create_changeStatusDesc') || '文件相关说明'
                  "
                  prop="changeStatusDesc"
                >
                  <el-input
                    v-model="form.changeStatusDesc"
                    :placeholder="
                      $l('form_placeholder_create_changeStatusDesc') ||
                        '请输入文件相关说明'
                    "
                    type="textarea"
                    maxlength="200"
                    :rows="4"
                    show-word-limit
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div style="text-align: center" v-if="!listDoc || !listDoc.length">
        <img src="/image/static/img/nodata.png" style="width: 120px;" />
        <div class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { VXETable } from 'vxe-table'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { request } from '@/api/service'
const initDoc = {
  custFileCode: '',
  custFileUrl: '',
  custFileName: '',
  custFileDescCodes: [],
  custFileDesc: '',
  changeStatusDesc: '',
}
export default {
  mixins: [EditLoading],
  props: { custCode: { type: String, default: '' } },
  data() {
    return {
      formData: {},
      listDoc: [],
      rules: {},
      docRules: {
        custFileName: [
          {
            required: true,
            message: this.$l('form_placeholder_custFile') || '请选择文件',
            trigger: 'change',
          },
        ],
        custFileDescCodes: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custFileDesc') ||
              '请选择文件类型（可多选）',
            trigger: 'change',
          },
        ],
        changeStatusDesc: [
          {
            required: true,
            message:
              this.$l('form_placeholder_create_changeStatusDesc') ||
              '请输入文件相关说明',
            trigger: 'blur',
          },
        ],
      },
      fileIcons: null,
    }
  },
  async activated() {
    await this.getFileIcons()
    this.init()
  },
  methods: {
    ...mapActions('admin/upload', ['push']),
    init() {
      this.getCustData()
      this.getDocData()
    },
    async getCustData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerV2DetailApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async getDocData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerDocFactoryInspectionApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      const data = res.body.data || []
      this.listDoc = data.map((item) => {
        return { ...item, custFileIcon: this.getFileIcon(item.custFileName) }
      })
    },
    async getFileIcons() {
      if (this.fileIcons) return
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
    },
    getFileIcon(fileName) {
      const getFileType = (filename) => {
        if (!filename) return ''
        if (!filename.includes('.')) return ''
        return filename.split('.').pop()
      }

      const fileType = getFileType(fileName) || 'OTHER'
      return this.$osscdn(
        this.fileIcons[fileType.toUpperCase()] || this.fileIcons['OTHER']
      )
    },
    addDoc() {
      this.listDoc.push({ ...initDoc })
    },
    async deleteDoc(index) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.listDoc.splice(index, 1)
    },
    async uploadDoc(index) {
      const { file } = await VXETable.readFile().catch(() => ({}))
      if (!file) return

      const { name, size } = file
      const custFileCode = await this.upload(file)

      this.listDoc[index].custFileCode = custFileCode
      this.listDoc[index].custFileName = name
      this.listDoc[index].custFileSize = this.formatFileSize(size)
      this.listDoc[index].custFileIcon = this.getFileIcon(name)
    },
    formatFileSize(bytes) {
      if (bytes >= 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(2) + 'MB'
      } else if (bytes >= 1024) {
        return (bytes / 1024).toFixed(2) + 'KB'
      } else {
        return bytes + 'B'
      }
    },
    upload(file) {
      return new Promise((resolve) => {
        this.push({
          file: file,
          added: ({ md5, suffix }) => {
            return resolve([md5, suffix].filter(Boolean).join('.'))
          },
          fail: () => resolve(),
        })
      })
    },
    validate() {
      return validate.formValidate([
        ...(this.$refs.form || []),
        this.$refs.baseForm,
      ])
    },
    async complete() {
      if (!(await this.validate())) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .masterCustomerSaveFactoryInspectionApi({
          ...this.formData,
          listDoc: this.listDoc,
          custCode: this.custCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return false
      if (res.status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-avatar {
    width: 80px;
    height: 80px;
    // background: transparent;
  }

  .cust-doc-list {
    .el-form {
      background-color: #f4f6f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
    .no-data {
      color: #606266;
      font-size: 13px;
    }
  }
}
</style>
